import React from 'react';

import { useCustomerActivityTemplateQuery } from 'generated/graphql';



export interface IData {
  logoUrl: string;
}

export function useQuery(storeId: string) {
  const tuple = useCustomerActivityTemplateQuery({
    variables: {
      storeId
    }
  });

  return React.useMemo(
    () => {
      const data: IData = {
        logoUrl: tuple.data?.storeBrand?.logoUrl ?? ''
      };

      return {
        ...tuple,
        data
      };
    },
    [tuple]
  );
}
